import styled from 'styled-components'
import { getFontStyle } from '@diversioteam/diversio-ds'

export const Input = styled.input`
    height: 41px;
    padding: 0;
    border: none;
    outline: none;
    background: inherit;

    color: ${({ theme }) => theme.colors.secondary500};

    ${getFontStyle('p02Medium')}
`
